export default import.meta.ROLLDOWN_FILE_URL_8zNhtWFBOfAe3WuL7mg5Ig